// extracted by mini-css-extract-plugin
export var header = "Header-module--header--10321";
export var hide = "Header-module--hide--12c98";
export var layout = "Header-module--layout--7d2cb";
export var link = "Header-module--link--54f21";
export var logo = "Header-module--logo--45d2a";
export var mobileNavOpen = "Header-module--mobile-nav-open--0a997";
export var transparent = "Header-module--transparent--542e3";
export var transparentBorder = "Header-module--transparent--border--0ae7a";